"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../../Button/Button"));
var _constants = require("../../../constants");
var _Toggle = _interopRequireDefault(require("../../../helpers/Toggle"));
var _ContactButton = _interopRequireDefault(require("../../../ContactUs/ContactButton"));
var _MobileMenu = _interopRequireDefault(require("./MobileMenu"));
var _Logo = _interopRequireDefault(require("../Logo"));
var _excluded = ["logo", "links", "user", "currencyHidden", "template", "showContact", "brand", "supportedCurrencies", "isPoweredBy"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Mobile = function Mobile(_ref) {
  var logo = _ref.logo,
    links = _ref.links,
    user = _ref.user,
    currencyHidden = _ref.currencyHidden,
    template = _ref.template,
    showContact = _ref.showContact,
    brand = _ref.brand,
    supportedCurrencies = _ref.supportedCurrencies,
    isPoweredBy = _ref.isPoweredBy,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--mobile flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--mobile__left"
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    config: logo,
    iconClassName: "icon--xl"
  })), showContact && /*#__PURE__*/_react["default"].createElement(_ContactButton["default"], {
    text: "",
    brand: brand,
    isPoweredBy: isPoweredBy
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--mobile__right"
  }, /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var on = _ref2.on,
      toggle = _ref2.toggle;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "hamburger",
      buttonType: _constants.BUTTON_TYPES.BARE_NO_PADDING,
      icon: "hamburger",
      onClick: toggle,
      buttonSize: _constants.BUTTON_SIZES.XXLARGE
    }), /*#__PURE__*/_react["default"].createElement(_MobileMenu["default"], (0, _extends2["default"])({}, props, {
      on: on,
      toggle: toggle,
      links: links,
      logo: logo,
      user: user,
      currencyHidden: currencyHidden,
      template: template,
      supportedCurrencies: supportedCurrencies
    })));
  })));
};
Mobile.propTypes = {
  logo: _propTypes["default"].object,
  links: _propTypes["default"].arrayOf(_propTypes["default"].object),
  user: _propTypes["default"].object,
  currencyHidden: _propTypes["default"].bool,
  template: _propTypes["default"].string,
  isPoweredBy: _propTypes["default"].bool
};
var _default = exports["default"] = Mobile;